import React, { useState } from 'react';
import { getNavIconClass } from '../../../navigation/clinicNavConfig';
import {
    ARTICLE_CATEGORY_THEMES,
    getArticleCategoryIcon,
    getArticleCategoryTheme,
} from './subparts/articlesCategoryTheme';

function TreeView({
    categories = [],
    parentId = 0,
    selectedCategoryId,
    onSelectCategory,
    onShowAll,
    depth = 0,
}) {
    const [expandedCategories, setExpandedCategories] = useState([]);

    const categoryHasChildren = (categoryId) =>
        categories.some((category) => category.parentCategoryId === categoryId);

    const toggleExpanded = (categoryId) => {
        setExpandedCategories((prev) =>
            prev.includes(categoryId) ? prev.filter((id) => id !== categoryId) : [...prev, categoryId]
        );
    };

    const handleCategoryClick = (category) => {
        const hasChildren = categoryHasChildren(category.id);

        if (hasChildren) {
            toggleExpanded(category.id);
            return;
        }

        onSelectCategory(category.id, category.title);
    };

    const renderCategories = (currentParentId) =>
        categories
            .filter((category) => category.parentCategoryId === currentParentId)
            .map((category) => {
                const hasChildren = categoryHasChildren(category.id);
                const isExpanded = expandedCategories.includes(category.id);
                const isSelected = selectedCategoryId === category.id;
                const theme = getArticleCategoryTheme(category, { hasChildren, isExpanded });
                const icon = getArticleCategoryIcon({ hasChildren, isExpanded });
                const childCount = hasChildren
                    ? categories.filter((cat) => cat.parentCategoryId === category.id).length
                    : 0;

                return (
                    <div key={category.id} className="articles-tree-item">
                        <button
                            type="button"
                            className={`articles-category-item ${isSelected ? 'is-active' : ''}`}
                            onClick={() => handleCategoryClick(category)}
                            aria-expanded={hasChildren ? isExpanded : undefined}
                        >
                            {hasChildren && (
                                <span
                                    className={`articles-tree-chevron ${isExpanded ? 'is-expanded' : ''}`}
                                    aria-hidden="true"
                                >
                                    <i className="bi bi-chevron-right"></i>
                                </span>
                            )}
                            <span className={`articles-category-item__icon ecx-nav-icon ${getNavIconClass(theme)}`}>
                                <i className={`bi ${icon}`}></i>
                            </span>
                            <span className="articles-category-item__label">{category.title}</span>
                            {hasChildren && (
                                <span className="articles-category-item__count">{childCount}</span>
                            )}
                        </button>

                        {hasChildren && (
                            <div
                                className={`articles-tree-children${isExpanded ? ' is-open' : ''}`}
                                aria-hidden={!isExpanded}
                            >
                                <div className="articles-tree-children__inner">
                                    {renderCategories(category.id)}
                                </div>
                            </div>
                        )}
                    </div>
                );
            });

    return (
        <div className="articles-category-list">
            <button
                type="button"
                className={`articles-category-item ${selectedCategoryId === null ? 'is-active' : ''}`}
                onClick={onShowAll}
            >
                <span
                    className={`articles-category-item__icon ecx-nav-icon ${getNavIconClass(ARTICLE_CATEGORY_THEMES.all)}`}
                >
                    <i className="bi bi-journals"></i>
                </span>
                <span className="articles-category-item__label">All Articles</span>
            </button>

            {categories.length > 0 ? (
                renderCategories(parentId, depth)
            ) : (
                <div className="ecx-page-empty py-3">
                    <div
                        className="ecx-page-empty__icon"
                        style={{ width: '2.5rem', height: '2.5rem', fontSize: '1.1rem' }}
                    >
                        <i className="bi bi-inbox"></i>
                    </div>
                    <p className="mb-0 small">No categories available</p>
                </div>
            )}
        </div>
    );
}

export default TreeView;
